import XIcon from '@/shared-components/icons/components/public/XIcon';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';
import Text from '@/shared-components/text/components/Text';

import './styles/ConfirmVisibilityChange.css';

export default function ConfirmVisibilityChange({ artwork, close, changeArtworkVisibility }) {

  const getMessage = (artwork) => {
    if (!artwork?.product_metadata.is_private) {
      return 'By making the artwork private, it will remain hidden in your profile collection, and other users will not be able to see that you are the owner. You can change this preference at any time.';
    } else {
      return 'By making the artwork public, it will appear in your profile collection, and other users will be able to see that you are the owner. You can change this preference at any time.';
    }
  };

  return (
    <>
      <GenericPopup
        open={Boolean(artwork)}
        className="collection-confirm-visibility"
        opacity
      >
        <div className="collection-confirm-visibility__header">
          <Text className="collection-confirm-visibility__header-text" medium>
            {
              !artwork?.product_metadata.is_private ?
                'Set artwork to private'  // Change title when setting to private
                :
                'Set artwork to public'   // Change title when setting to public
            }
          </Text>

          <XIcon className="collection-confirm-visibility__close" onClick={close}/>
        </div>

        <Text className="collection-confirm-visibility__text" paragraph justify small>
          {getMessage(artwork)}
        </Text>

        <div className="collection-confirm-visibility__buttons">
          <Text className="collection-confirm-visibility__button cancel" onClick={close} medium>
                            Cancel
          </Text>

          {
            !artwork?.product_metadata.is_private ?
              <Text 
                className="collection-confirm-visibility__button confirm" 
                medium
                onClick={()=>{
                  changeArtworkVisibility(artwork, true);
                  close();
                }} 
              >
                                    Make it private
              </Text>
              :
              <Text 
                className="collection-confirm-visibility__button confirm" 
                medium
                onClick={()=>{
                  changeArtworkVisibility(artwork, false);
                  close();
                }} 
              >
                                    Make it public
              </Text>
          }
        </div>
      </GenericPopup>
    </>
  );
}
